import React from 'react';

import { Stack, Typography } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid';

import DebugModal from '~/components/DebugModal/DebugModal';

function PromoDetails({ row }: GridRenderCellParams<App.PromoData>) {
  return (
    <Stack direction="column" spacing={2}>
      <Typography>{row.popup_message_presented_example}</Typography>
      {row.loyalty_points_bonus_config && (
        <DebugModal
          title={row.loyalty_points_bonus_config}
          data={{
            mode: row.loyalty_points_bonus_config,
            options: row.promo_discounts.map((discount) => discount.loyalty_points_bonus_config),
            promo_discounts: row.promo_discounts,
          }}
          type="generic"
        />
      )}
      <DebugModal title="Details" data={row} type="generic" />
    </Stack>
  );
}

export default PromoDetails;
